/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Status_AmbiguousInputs */

const cs_pm_status_ambiguous = /** @type {(inputs: Pm_Status_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejisté`)
};

const en_pm_status_ambiguous = /** @type {(inputs: Pm_Status_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsure`)
};

/**
* | output |
* | --- |
* | "Unsure" |
*
* @param {Pm_Status_AmbiguousInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_status_ambiguous = /** @type {((inputs?: Pm_Status_AmbiguousInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Status_AmbiguousInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_status_ambiguous(inputs)
	return cs_pm_status_ambiguous(inputs)
});